import { CalendarAssignment } from '../types/interfaces';

export const CalendarAssignmentTemplate: CalendarAssignment = {
  employees: [],
  calendar: {}
};
